module.exports = __webpack_public_path__ + "img/companyApply.4847fdae.png";